/**
 * One way to render a student's display name.
 *
 * The name is stored in three parts: firstName, middleName (the father's name
 * in Arabic naming) and lastName (the family name). Several screens used to
 * join first + last only, which was harmless while the onboarding approver
 * packed "<father> <family>" into lastName — and started dropping the father's
 * name the moment that field became family-only. Joining all three parts keeps
 * imported, onboarded and hand-added students reading the same.
 */

export function studentFullName(student, fallback = '') {
  if (!student) return fallback;
  const full = [student.firstName, student.middleName, student.lastName]
    .map((part) => (part == null ? '' : String(part).trim()))
    .filter(Boolean)
    .join(' ');
  return full || student.fullName || student.name || fallback;
}

/** Initials for an avatar: first letter of the first and family names. */
export function studentInitials(student, fallback = '?') {
  if (!student) return fallback;
  const first = (student.firstName || '').trim().charAt(0);
  const last = (student.lastName || '').trim().charAt(0);
  return `${first}${last}`.toUpperCase() || studentFullName(student).charAt(0) || fallback;
}
